var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings-font"},[_c('label',{attrs:{"title":_vm.name}},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('img',{attrs:{"src":_vm.overviewUrl,"alt":_vm.t('richdocuments', 'No font overview')}}),_vm._v(" "),_c('button',{class:{
			'icon-delete': true,
			svg: true,
			'loading-small': _vm.disabled,
		},attrs:{"disabled":_vm.disabled,"title":_vm.t('richdocuments', 'Delete this font')},on:{"click":_vm.onDeleteClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }